// Mock data for AP Glass Railings website

export const companyInfo = {
  name: "AP Glass Railings",
  owner: "Alen Polosi",
  phone: "6042203800",
  email: "apglassrailings@yahoo.com",
  location: "Lower Mainland, BC",
  yearsOfExperience: 20,
  tagline: "Premium Glass & Aluminum Railing Solutions",
  description: "With 20 years of experience serving the Lower Mainland, BC, AP Glass Railings delivers exceptional craftsmanship in glass and aluminum railing installations."
};

export const services = [
  {
    id: 1,
    title: "Glass Railings",
    description: "Premium frameless and framed glass railing systems for residential and commercial properties. Providing unobstructed views with maximum safety.",
    features: ["Frameless Design", "Tempered Safety Glass", "Custom Sizing", "Weather Resistant"]
  },
  {
    id: 2,
    title: "Aluminum Railings",
    description: "Durable, low-maintenance aluminum railing solutions. Perfect for decks, balconies, and staircases with various design options.",
    features: ["Powder Coated Finish", "Corrosion Resistant", "Multiple Colors", "Easy Maintenance"]
  },
  {
    id: 3,
    title: "Custom Installations",
    description: "Tailored railing solutions designed to meet your specific needs and architectural requirements. From concept to completion.",
    features: ["Design Consultation", "Professional Installation", "Quality Materials", "Warranty Included"]
  }
];

export const galleryImages = [
  {
    id: 1,
    url: "https://customer-assets.emergentagent.com/job_polosi-railings/artifacts/h5ab1tb1_IMG_1736.jpeg",
    title: "Lakefront Deck - Black Aluminum Railings",
    category: "aluminum"
  },
  {
    id: 2,
    url: "https://customer-assets.emergentagent.com/job_polosi-railings/artifacts/55b1pdce_IMG_2550.jpeg",
    title: "Interior Loft Glass Railings",
    category: "glass"
  },
  {
    id: 3,
    url: "https://customer-assets.emergentagent.com/job_polosi-railings/artifacts/9nk9bie6_IMG_4361.jpeg",
    title: "Frosted Glass Privacy Screen",
    category: "glass"
  },
  {
    id: 4,
    url: "https://customer-assets.emergentagent.com/job_polosi-railings/artifacts/que2l8cl_20251129_142717.jpeg",
    title: "Modern Home Glass Deck Railings",
    category: "glass"
  },
  {
    id: 5,
    url: "https://customer-assets.emergentagent.com/job_polosi-railings/artifacts/68qhurhu_20260115_153628.jpeg",
    title: "Multi-Level Residential Glass Installation",
    category: "mixed"
  },
  {
    id: 6,
    url: "https://customer-assets.emergentagent.com/job_polosi-railings/artifacts/h5ab1tb1_IMG_1736.jpeg",
    title: "Waterfront Property Aluminum Railings",
    category: "aluminum"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Mitchell",
    location: "Vancouver, BC",
    rating: 5,
    text: "AP Glass Railings transformed our deck with beautiful frameless glass. Professional service from start to finish!"
  },
  {
    id: 2,
    name: "David Chen",
    location: "Burnaby, BC",
    rating: 5,
    text: "Excellent craftsmanship and attention to detail. Our aluminum railings look amazing and are built to last."
  },
  {
    id: 3,
    name: "Jennifer Thompson",
    location: "Surrey, BC",
    rating: 5,
    text: "Alen and his team were fantastic. They completed our glass railing installation on time and within budget."
  }
];

export const quoteFormSubmit = (formData) => {
  // Mock submission - in production this will send to backend
  console.log("Quote request submitted:", formData);
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({ success: true, message: "Quote request received! We'll contact you within 24 hours." });
    }, 1000);
  });
};
